export default "__VITE_ASSET__GvX9OvUn__"